import { selectWorkflowMetadata } from '../features/workflow/selectors';
import { useAppSelector } from '../hooks';

export const useValidBatches = (): {
  maxBatches: number;
  minBatch: number;
  validBatches: number[];
} => {
  const workflowMetadata = useAppSelector(selectWorkflowMetadata);

  if (!workflowMetadata) {
    return { maxBatches: 0, minBatch: 0, validBatches: [] };
  }

  const { validBatchNumbers } = workflowMetadata.validBatchData;

  return {
    maxBatches:
      validBatchNumbers.length > 0 ? Math.max(...validBatchNumbers) : 0,
    minBatch: validBatchNumbers.length > 0 ? Math.min(...validBatchNumbers) : 0,
    validBatches: validBatchNumbers,
  };
};
